import {
  Button,
  TextField,
  Box,
  Grid,
  Paper,
  useMediaQuery,
} from '@mui/material';
import { Form, Formik } from 'formik';

const UserForm = (props: any) => {
  const { entity, onSubmit, errors, handleCancel } = props;
  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down('sm')
  );

  return (
    <Formik
      initialValues={entity}
      enableReinitialize={true}
      validate={(values) => {
        const errors: any = {};
        if (!values.fullName) {
          errors.fullName = 'Kötelező mező';
        }

        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({
        isSubmitting,
        values,
        touched,
        handleChange,
        errors: validationErrors,
      }) => (
        <Form>
          {' '}
          <Paper>
            <Grid
              container
              spacing={2}
              sx={{
                justifyContent: "left",
                p: 5
              }}>
              <h2>
                Felhasználó {values.id > 0 ? 'szerkesztése' : 'létrehozása'}
              </h2>
              <Grid size={12} sx={{
                pt: 5
              }}>
                <Box sx={{
                  color: "red"
                }}>
                  {errors.map((error: string) => (
                    <li>{error}</li>
                  ))}
                </Box>
              </Grid>
              <Grid size={12}>
                <TextField
                  value={values.fullName}
                  onChange={handleChange}
                  label="Megjelenítési név"
                  name="fullName"
                  fullWidth
                  autoFocus
                  error={!!touched.fullName && !!validationErrors.fullName}
                  helperText={
                    !!touched.fullName &&
                    !!validationErrors.fullName &&
                    (validationErrors.fullName as string)
                  }
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  value={values.email}
                  onChange={handleChange}
                  label="Email"
                  name="UserEmail"
                  disabled
                  fullWidth
                  error={!!touched.email && !!validationErrors.email}
                  helperText={
                    !!touched.email &&
                    !!validationErrors.email &&
                    (validationErrors.email as string)
                  }
                />
              </Grid>
              <Grid
                container
                sx={{
                  pt: 3,
                  justifyContent: "left"
                }}>
                <Grid size={{ xs: 12, sm: isSmallScreen ? 12 : 'auto' }} sx={{
                  p: 1
                }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth={isSmallScreen}
                    disabled={isSubmitting}
                  >
                    Mentés
                  </Button>
                </Grid>

                <Grid size={{ xs: 12, sm: isSmallScreen ? 12 : 'auto' }} sx={{
                  p: 1
                }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth={isSmallScreen}
                    onClick={handleCancel}
                  >
                    Mégse
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
      )}
    </Formik>
  );
};

export default UserForm;
